import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TableService {
  private _dataLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  /**
   * Streams a boolean telling if the data table is loading or not.
   */
  get dataLoading$(): Observable<boolean> {
    return this._dataLoading$.asObservable();
  }

  /**
   * Set data loading.
   */
  setDataLoading(value: boolean) {
    this._dataLoading$.next(value);
  }
}
